import {State} from '../../Store';
import {Store} from 'vuex';
import {
	EditorNumericSliderMutation,
	EditorNumericSliderShowOptions,
	EditorNumericSliderState,
} from '../../modules/editor/NumericSlider';
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Vector2Like} from '../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';

export class EditorNumericSliderStoreControllerClass {
	private _store!: Store<State>;

	private static _instance: EditorNumericSliderStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorNumericSliderStoreControllerClass());
	}

	private constructor() {}

	set_store(store: Store<State>) {
		this._store = store;
	}

	// getters
	get local_state(): EditorNumericSliderState {
		return (<unknown>(this._store.state.editor as any).numeric_slider) as EditorNumericSliderState;
	}
	param_id(): CoreGraphNodeId | null {
		return this.local_state.param_id;
	}
	position(): Vector2Like {
		return this.local_state.position;
	}

	// mutations
	open(options: EditorNumericSliderShowOptions): void {
		this._store.commit(`editor/numeric_slider/${EditorNumericSliderMutation.OPEN}`, options);
	}
	close() {
		this._store.commit(`editor/numeric_slider/${EditorNumericSliderMutation.CLOSE}`);
	}
}

export const EditorNumericSliderStoreController = EditorNumericSliderStoreControllerClass.instance();
